import { type Product } from "@fitness-app/data-models/entities/Product";

export const DEFAULT_STRIPE_ACCOUNT_KEY = "__default__";
export const DEFAULT_STRIPE_ACCOUNT_LABEL = "Główne";

type StripeOptionsByKey = Record<string, { name: string; isDefault?: boolean }>;

/** The Stripe account a product sells through; a missing or default account counts as the main one. */
export const getProductStripeAccountKey = (
  product: Pick<Product, "customStripeAccount">,
  stripeOptionsByKey: StripeOptionsByKey,
) => {
  const account = product.customStripeAccount ? stripeOptionsByKey[product.customStripeAccount] : undefined;

  return product.customStripeAccount && account && !account.isDefault
    ? product.customStripeAccount
    : DEFAULT_STRIPE_ACCOUNT_KEY;
};

export const getStripeAccountLabel = (key: string, stripeOptionsByKey: StripeOptionsByKey) =>
  key === DEFAULT_STRIPE_ACCOUNT_KEY ? DEFAULT_STRIPE_ACCOUNT_LABEL : (stripeOptionsByKey[key]?.name ?? key);
